import styles from './styles.module.scss';

import {
    AcademicUser,
    AcademicUserClass,
    AcademicUserSchool,
    GenericType,
    Role,
    UserOptions
} from '../../../../../../types';
import { Input } from '../../../../../../components/Input';
import { FormControl } from '../../../../../../components/FormControl';
import ProfileImage from '../../../../../../assets/images/icons/profile/white-mode-user-profile.png';
import { Select } from '../../../../../../components/Select';
import { MultipleSelect } from '../../../../../../components/MultipleSelect';
import { useContext, useEffect, useRef, useState } from 'react';
import { TokenItem } from '../../../../../../components/Token';
import { Tokenizer } from '../../../../../../components/Tokenizer';
import { Button } from '../../../../../../components/Button';
import { isEqual } from 'lodash';
import { maxImageUpload } from '../../../../../../globalFunctions';
import { MessageContext } from '../../../../../../providers/MessageProvider';
import axios  from 'axios';

interface SchoolTokenItem extends TokenItem {
    enrollment?: string;
    idAcademicRole?: number;
}

type LogicManagerUserDetailProps = {
    user: AcademicUser | undefined;
    setUser: React.Dispatch<React.SetStateAction<AcademicUser | undefined>>;
    options: UserOptions;
    onSave: React.MouseEventHandler<HTMLButtonElement>;
    onRestore: React.MouseEventHandler<HTMLButtonElement>;
    onDelete: React.MouseEventHandler<HTMLButtonElement>;
};

type Notas = {
    abstracao: number;
    padroes: number;
    algoritimos: number;
    decomposicao: number;

} 

export const LogicManagerUserDetail = ({
    user,
    setUser,
    options,
    onSave,
    onRestore,
    onDelete
}: LogicManagerUserDetailProps) => {
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const imageInputRef = useRef<HTMLInputElement>(null);
    const [selectedRoles, setSelectedRoles] = useState<TokenItem[]>([]);
    const [selectedSchools, setSelectedSchools] = useState<SchoolTokenItem[]>([]);
    const [selectedClasses, setSelectedClasses] = useState<TokenItem[]>([]);
    const [notas,setNotas] = useState<Notas>({
        abstracao: 0,
        padroes: 0,
        algoritimos: 0,
        decomposicao: 0,
 } );

    const handleImage = () => {
        if (imageInputRef.current) {
            imageInputRef.current.click();
        }
    };

    const getNota = async (id) =>   {
        if(user) {
            try {
                const resposta =  await  axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/nota/${user.id}`)
                setNotas(resposta.data)
                console.log(resposta)
    
            } catch(error) {
                const response = {
                    message: 'Erro ao buscar status dos módulos',
                    error: error
                };
        
               return response;
            }

        }

        
    }

    const onImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        try {
            if (event.target.files && event.target.files.length > 0 && user) {
                const selectedImage = event.target.files[0];

                if (selectedImage.size > maxImageUpload()) {
                    if (imageInputRef.current) {
                        imageInputRef.current.value = '';
                    }

                    throw new Error('Imagem excede o limite de 10MB');
                } else {
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        user.image = {
                            id: 0,
                            url: reader.result as string,
                            file: selectedImage,
                            removeId: user.image && user.image.id ? user.image.id : 0
                        };

                        setUser({ ...user });
                    };
                    reader.readAsDataURL(selectedImage);
                }
            }
        } catch (error: any) {
            setMessage({
                type: 'error',
                content: error.message ?? 'Erro ao fazer upload da imagem'
            });
            setOpenMessage(true);
        }
    };

    const onFormControlChange = (event: any, prop: string) => {
        if (user) {
            user[prop] = event.target.value;

            if (prop === 'email') {
                user.email_verified_at = null;
            }

            setUser({ ...user });
        }
    };

    const onAcademicEnrollmentChange = (
        event: any,
        academicEnrollment: SchoolTokenItem,
        prop: string
    ) => {
        const currentSelectedSchools: SchoolTokenItem[] = [];

        selectedSchools.forEach(selectedSchool => {
            if (selectedSchool.key === academicEnrollment.key) {
                selectedSchool[prop] = event.target.value;
            }

            currentSelectedSchools.push(selectedSchool);
        });

        setSelectedSchools(currentSelectedSchools);
    };

    const renderAcademicEnrollment = (academicEnrollment: SchoolTokenItem) => {
        academicEnrollment.enrollment = academicEnrollment.enrollment
            ? academicEnrollment.enrollment
            : '';
        academicEnrollment.idAcademicRole = academicEnrollment.idAcademicRole
            ? academicEnrollment.idAcademicRole
            : 0;

        return (
            <div
                key={`academicUser-wrapper-${academicEnrollment.key}`}
                className={styles.academicEnrollmentItem}
            >
                <FormControl
                    key={`academicUser-formControl-enrollment-${academicEnrollment.key}`}
                    flexDirection='row'
                    label={`${academicEnrollment.text}`}
                    inputId={`academicUser-input-enrollment-${academicEnrollment.key}`}
                >
                    <Input
                        key={`academicUser-input-enrollment-${academicEnrollment.key}`}
                        id={`academicUser-input-enrollment-${academicEnrollment.key}`}
                        inputWrapperClass={styles.field}
                        type='text'
                        //placeholder='Digite a matrícula do usuário na instituição'
                        value={academicEnrollment.enrollment}
                        onChange={(e: any) =>
                            onAcademicEnrollmentChange(e, academicEnrollment, 'enrollment')
                        }
                        disabled={user ? !user.is_active : true}
                    />
                </FormControl>

                <Select
                    key={`academicUser-input-academicRole-${academicEnrollment.key}`}
                    id={`academicUser-input-academicRole-${academicEnrollment.key}`}
                    selectWrapperClass={styles.field}
                    options={[
                        { key: 'empty', value: 0, text: 'Selecione uma função acadêmica' }
                    ].concat(options.academicRoles)}
                    value={academicEnrollment.idAcademicRole}
                    onChange={(e: any) =>
                        onAcademicEnrollmentChange(e, academicEnrollment, 'idAcademicRole')
                    }
                    disabled={user ? !user.is_active : true}
                />
            </div>
        );
    };

    useEffect(() => {
        if (user) {
            // Roles
            const userRoles: TokenItem[] = [];

            user.roles.forEach(role => {
                userRoles.push({
                    key: role.internal_type,
                    value: role.id,
                    text: role.name
                });
            });

            setSelectedRoles(userRoles);

            // Schools
            const userSchools: SchoolTokenItem[] = [];

            user.schools.forEach(academic => {
                userSchools.push({
                    key: parseInt(academic.school.id.toString()),
                    value: parseInt(academic.id.toString()),
                    text: academic.school.slug,
                    title: academic.school.name,
                    enrollment: academic.enrollment,
                    idAcademicRole: academic.idAcademicRole
                });
            });

            setSelectedSchools(userSchools);

            // Classes
            const userClasses: TokenItem[] = [];

            user.classes.forEach(userClass => {
                const currentClass: any = userClass;

                if (currentClass.key) {
                    userClasses.push({
                        key: currentClass.key,
                        value: currentClass.value,
                        text: currentClass.text,
                        description: currentClass.description
                    });
                } else {
                    userClasses.push({
                        key: currentClass.id,
                        value: currentClass.school.id,
                        text: currentClass.name,
                        description: currentClass.school.slug
                    });
                }
            });

            setSelectedClasses(userClasses);
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            getNota(user.idUser)
            const currentRoles =
                selectedRoles.length === 0
                    ? []
                    : selectedRoles.map(role => {
                          return {
                              id: role.value,
                              internal_type: role.key,
                              name: role.text
                          } as Role;
                      });

            if (!isEqual(user.roles, currentRoles)) {
                if (!currentRoles.find(role => ['ACADEMIC'].includes(role.internal_type))) {
                    user.schools = [];
                    user.classes = [];
                }

                user.roles = currentRoles;
                setUser({ ...user });
            }
        }
    }, [selectedRoles]);

    useEffect(() => {
        if (user) {
            const currentSchools =
                selectedSchools.length === 0
                    ? []
                    : selectedSchools.map(academic => {
                          return {
                              id: academic.value ? academic.value : 0,
                              enrollment: academic.enrollment ? academic.enrollment : '',
                              idAcademicRole: academic.idAcademicRole ? academic.idAcademicRole : 0,
                              school: {
                                  id: academic.key,
                                  name: academic.title,
                                  slug: academic.text
                              }
                          } as AcademicUserSchool;
                      });

            const currentClasses =
                selectedClasses.length === 0
                    ? ([] as AcademicUserClass[])
                    : selectedClasses.filter(userClass => {
                          let render = false;

                          selectedSchools.forEach(selectedSchool => {
                              if (userClass.value === selectedSchool.key) {
                                  render = true;
                              }
                          });

                          if (render) {
                              return {
                                  id: userClass.key,
                                  name: userClass.text,
                                  school: {
                                      id: userClass.value,
                                      slug: userClass.description
                                  }
                              } as AcademicUserClass;
                          }
                      });

            if (!isEqual(user.schools, currentSchools)) {
                user.schools = currentSchools;

                if (!isEqual(user.classes, currentClasses)) {
                    user.classes = currentClasses as AcademicUserClass[];
                }

                setUser({ ...user });
            }
        }
    }, [selectedSchools]);

    useEffect(() => {
        if (user) {
            const currentClasses =
                selectedClasses.length === 0
                    ? []
                    : selectedClasses.map(userClass => {
                          return {
                              id: userClass.key,
                              name: userClass.text,
                              school: {
                                  id: userClass.value,
                                  slug: userClass.description
                              }
                          } as AcademicUserClass;
                      });

            if (!isEqual(user.classes, currentClasses)) {
                user.classes = currentClasses;
                setUser({ ...user });
            }
        }
    }, [selectedClasses]);

    return (
        <div className={styles.wrapper}>
            {user ? (
                <>
                    <div className={styles.btnBox}>
                        <div className={styles.btnBoxGroup}>
                            {user.is_active ? (
                                <>
                                    <Button type='error' title='Desativar' onClick={onDelete}>
                                        <div className='fa fa-ban' aria-hidden='true' />
                                    </Button>

                                    <Button type='success' title='Salvar' onClick={onSave}>
                                        <div className='fa fa-check' aria-hidden='true' />
                                    </Button>
                                </>
                            ) : (
                                <Button type='warning' title='Ativar' onClick={onRestore}>
                                    <div className='fa fa-undo' aria-hidden='true' />
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className={styles.notasContainer}>
</div>
                    <div className={styles.container}>
                        <div className={styles.profile}>
                        <h4>Notas do usuário</h4>
                        <table className={styles.notasTable}>
                            <thead>
                            <tr>
                                <th>Abstração</th>
                                <th>Padrões</th>
                                <th>Algoritmos</th>
                                <th>Decomposição</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{notas.abstracao}</td>
                                <td>{notas.padroes}</td>
                                <td>{notas.algoritimos}</td>
                                <td>{notas.decomposicao}</td>
                            </tr>
                            </tbody>
                        </table>
                            <div
                                className={`${styles.profileImage} ${
                                    !user.image && styles.fakeImage
                                }`}
                                onClick={handleImage}
                            >
                                <img
                                    src={user.image ? user.image.url : ProfileImage}
                                    alt={`Imagem de perfil de ${user.name}`}
                                />
                                <div className={styles.hoverImage}>
                                    <div className='fa fa-plus' aria-hidden='true' />
                                    <input
                                        className={styles.imageInput}
                                        type='file'
                                        accept='image/png, image/jpeg, image/jpg'
                                        id='image'
                                        name='image'
                                        onChange={onImageChange}
                                        ref={imageInputRef}
                                        disabled={!user.is_active}
                                    />
                                </div>
                            </div>
                            {user.last_login && (
                                <div className={styles.stats}>Último login: {user.last_login}</div>
                            )}
                            <div className={styles.stats}>
                                Aceitou a LGPD:&nbsp;
                                {user.lgpd_agreed ? (
                                    <div
                                        className={`fa fa-check-circle ${styles.checkIcon} ${styles.verified}`}
                                        aria-hidden='true'
                                    />
                                ) : (
                                    <div
                                        className={`fa fa-times-circle ${styles.checkIcon} ${styles.unverified}`}
                                        aria-hidden='true'
                                    />
                                )}
                            </div>
                        </div>

                        <div className={styles.row}>
                            <FormControl
                                key='formControlName'
                                flexDirection='column'
                                wrapperClass={styles.three}
                                label='Nome'
                                inputId='name'
                            >
                                <Input
                                    key='inputName'
                                    inputWrapperClass={styles.field}
                                    id='name'
                                    type='text'
                                    value={user.name}
                                    onChange={(e: any) => onFormControlChange(e, 'name')}
                                    disabled={!user.is_active}
                                />
                            </FormControl>

                            <FormControl
                                key='formControlSurname'
                                flexDirection='column'
                                wrapperClass={styles.five}
                                label='Sobrenome'
                                inputId='surname'
                            >
                                <Input
                                    key='inputSurname'
                                    inputWrapperClass={styles.field}
                                    id='surname'
                                    type='text'
                                    value={user.surname}
                                    onChange={(e: any) => onFormControlChange(e, 'surname')}
                                    disabled={!user.is_active}
                                />
                            </FormControl>

                            <FormControl
                                key='formControlGender'
                                flexDirection='column'
                                wrapperClass={styles.zero}
                                label='Gênero'
                                inputId='gender'
                            >
                                <Select
                                    key='selectGender'
                                    selectWrapperClass={styles.field}
                                    id='gender'
                                    options={options.genders}
                                    value={user.gender}
                                    onChange={(e: any) => onFormControlChange(e, 'gender')}
                                    disabled={!user.is_active}
                                />
                            </FormControl>
                        </div>

                        <div className={styles.row}>
                            <FormControl
                                key='formControlEmail'
                                flexDirection='column'
                                wrapperClass={styles.emailRow}
                                label='E-mail'
                                inputId='email'
                            >
                                <div className={styles.email}>
                                    <Input
                                        key='inputEmail'
                                        inputWrapperClass={styles.field}
                                        id='email'
                                        type='text'
                                        value={user.email}
                                        onChange={(e: any) => onFormControlChange(e, 'email')}
                                        disabled={!user.is_active}
                                    />
                                    {user.email_verified_at !== null ? (
                                        <div
                                            className={`${styles.checkIcon} ${styles.verified}`}
                                            hidden={user.email_verified_at !== null}
                                        >
                                            <div
                                                className={`fa fa-check-circle ${styles.checkIcon}`}
                                                aria-hidden='true'
                                            />
                                            Verificado
                                        </div>
                                    ) : (
                                        <div
                                            className={`${styles.checkIcon} ${styles.unverified}`}
                                            hidden={user.email_verified_at === null}
                                        >
                                            <div
                                                className={`fa fa-times-circle ${styles.checkIcon}`}
                                                aria-hidden='true'
                                            />
                                            Não verificado
                                        </div>
                                    )}
                                </div>
                            </FormControl>
                        </div>

                        <div className={styles.centerRow}>
                            <MultipleSelect
                                key='multipleSelectRoles'
                                id='multipleSelectRoles'
                                options={options.roles}
                                selectedOptions={selectedRoles}
                                setSelectedOptions={setSelectedRoles}
                                placeholder='Perfil de acesso'
                                title='Perfis de acesso do usuário'
                                disabled={!user.is_active}
                            />

                            <Tokenizer
                                key='tokenizerRoles'
                                id='tokenizerRoles'
                                wrapperText={styles.tokenText}
                                tokens={selectedRoles}
                                setTokens={setSelectedRoles}
                                deletable={false}
                            />
                        </div>

                        {selectedRoles.find(role => ['ACADEMIC'].includes(role.key)) && (
                            <>
                                <div className={styles.centerRow}>
                                    <MultipleSelect
                                        key='multipleSelectSchools'
                                        id='multipleSelectSchools'
                                        options={options.schools}
                                        selectedOptions={selectedSchools}
                                        setSelectedOptions={setSelectedSchools}
                                        placeholder='Instituições'
                                        title='Vincular instituições'
                                        disabled={!user.is_active}
                                    />

                                    <Tokenizer
                                        key='tokenizerSchools'
                                        id='tokenizerSchools'
                                        wrapperText={styles.tokenText}
                                        tokens={selectedSchools}
                                        setTokens={setSelectedSchools}
                                        deletable={false}
                                    />
                                </div>

                                {selectedSchools.length > 0 && (
                                    <div className={styles.academicEnrollment}>
                                        {selectedSchools.map(renderAcademicEnrollment)}
                                    </div>
                                )}

                                {options.classes.filter(classOption => {
                                    let show = false;

                                    selectedSchools.forEach(school => {
                                        if (classOption.value === school.key) {
                                            show = true;
                                        }
                                    });

                                    return show;
                                }).length > 0 && (
                                    <div className={styles.centerRow}>
                                        <MultipleSelect
                                            key='multipleSelectClasses'
                                            id='multipleSelectClasses'
                                            options={options.classes.filter(classOption => {
                                                let show = false;

                                                selectedSchools.forEach(school => {
                                                    if (classOption.value === school.key) {
                                                        show = true;
                                                    }
                                                });

                                                return show;
                                            })}
                                            selectedOptions={selectedClasses}
                                            setSelectedOptions={setSelectedClasses}
                                            placeholder='Turmas'
                                            title='Vincular turmas'
                                            disabled={!user.is_active}
                                        />

                                        <Tokenizer
                                            key='tokenizerClasses'
                                            id='tokenizerClasses'
                                            wrapperText={styles.tokenText}
                                            wrapperDescription={styles.tokenDescription}
                                            tokens={selectedClasses}
                                            setTokens={setSelectedClasses}
                                            deletable={false}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </>
            ) : (
                'Selecione um usuário'
            )}
        </div>
    );
};
